<div class="flex column align-items-center step-layout">
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32">
      <div class="flex column align-items-center gap-4">
        <span class="typo-title-3 p-4">Create Password</span>
        <span class="typo-text-2 text-medium text-align-center"
          >The password cannot be restored</span
        >
        <!-- <div class="address-container">
          <span class="typo-text-3 text-medium text-align-center">
            {{ displayWalletAddress() }}
          </span>
          <div (click)="copyAddressToClipboard()" class="clickable">
            <kc-icon iconClass="icon-copy"></kc-icon>
          </div>
        </div> -->
      </div>
      <div class="password-notice">
        <kc-icon
          iconClass="icon-info"
          [size]="'sm'"
          color="var(--warning-color, #FFB800)"
        />
        <p class="password-notice__message typo-text-3">
          <span class="password-notice__label">Important:</span>
          This password unlocks your wallet data. If you lose it, you will not
          be able to recover your wallet data. Please make sure to save it
          somewhere safe.
        </p>
      </div>
      <form
        class="flex column gap-16 full-width align-items-stretch align-self-stretch"
        [formGroup]="passwordForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="flex column gap-4">
          <kc-input
            class="full-width"
            formControlName="password"
            [infoLabel]="{ label: 'Enter your password' }"
            [placeholder]="'Password'"
            [type]="passwordType()"
            [isValid]="!isInvalid('password')"
            (keydown.enter)="onSubmit()"
          >
            <div (click)="togglePwVisibility()" class="clickable" rightSideSlot>
              <kc-icon iconClass="{{ passwordIcon() }}" [size]="'xs'" />
            </div>
          </kc-input>
          @if (isInvalid("password") && getPasswordErrorMessage()) {
            <span class="kc-input-error-text">{{
              getPasswordErrorMessage()
            }}</span>
          }
          <kc-input
            class="full-width"
            formControlName="confirmPassword"
            [infoLabel]="{ label: 'Confirm your password' }"
            [placeholder]="'Confirm password'"
            [type]="passwordConfirmType()"
            [isValid]="!isInvalid('confirmPassword')"
            (keydown.enter)="onSubmit()"
          >
            <div
              (click)="toggleConfirmPwVisibility()"
              class="clickable"
              rightSideSlot
            >
              <kc-icon [iconClass]="passwordConfirmIcon()" [size]="'xs'" />
            </div>
          </kc-input>
          @if (
            isInvalid("confirmPassword") && getConfirmPasswordErrorMessage()
          ) {
            <span class="kc-input-error-text">{{
              getConfirmPasswordErrorMessage()
            }}</span>
          }
        </div>
      </form>
    </div>
  </div>

  <div class="step-layout__buttons">
    <div class="flex full-width gap-16">
      <kc-button
        [isFullWidth]="true"
        [text]="'Back'"
        (buttonClick)="previous.emit()"
      />
      <kc-button
        [isFullWidth]="true"
        [text]="'Next'"
        (buttonClick)="onSubmit()"
        [isDisabled]="!passwordForm.valid"
      />
    </div>
  </div>
</div>
